angular.module("ainapp")
    .controller("accountBalanceController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Account Balance";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


               $scope.loadKendoFunc = function(){
                    $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {
                           // o.data.Keyword = $scope.filter.Keyword;

                            MainService.LedgerAccountBalances().then(function (response) {
                                 o.success({
                                    Data:response.data
                                });
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        },

                    },
                    
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                AccountCode: {
                                    type: "string",
                                    editable: false,
                                },
                                AccountName: {
                                    type: "string",
                                    editable: false,
                                },
                                ParentName: {
                                    type: "string",
                                    editable: false,
                                },
                                OpeningDebit: {
                                    type: "number",
                                    editable: false,
                                },
                                OpeningCredit: {
                                    type: "number",
                                    editable: false,
                                },
                                  DebitTotal: {
                                    type: "number",
                                    editable: false,
                                },
                                CreditTotal: {
                                    type: "number",
                                    editable: false,
                                },
                                BalanceDebit: {
                                    type: "number",
                                    editable: false,
                                },
                                 BalanceCredit: {
                                    type: "number",
                                    editable: false,
                                },
                                 Balance: {
                                    type: "number",
                                    editable: false,
                                },
                            }
                        }
                    },
                    // serverPaging: true,
                    // serverSorting: true,
                    // serverFiltering: true,
                     pageSize: 20,
                      group: [{
                        field: "ParentName",
                        aggregates: [
                            {
                                field: "OpeningDebit",
                                aggregate: "sum"
                                },
                                {
                                field: "OpeningCredit",
                                aggregate: "sum"
                                },
                                {
                                field: "DebitTotal",
                                aggregate: "sum"
                                },
                                {
                                field: "CreditTotal",
                                aggregate: "sum"
                                },
                                {
                                field: "BalanceDebit",
                                aggregate: "sum"
                                },
                                {
                                field: "BalanceCredit",
                                aggregate: "sum"
                                },
                                {
                                field: "Balance",
                                aggregate: "sum"
                                },
                            ]
                        }],
                    aggregate: [
                            {
                                field: "OpeningDebit",
                                aggregate: "sum"
                                },
                                {
                                field: "OpeningCredit",
                                aggregate: "sum"
                                },
                                {
                                field: "DebitTotal",
                                aggregate: "sum"
                                },
                                {
                                field: "CreditTotal",
                                aggregate: "sum"
                                },
                                {
                                field: "BalanceDebit",
                                aggregate: "sum"
                                },
                                {
                                field: "BalanceCredit",
                                aggregate: "sum"
                                },
                                {
                                field: "Balance",
                                aggregate: "sum"
                                },
                            ],
                });

                $scope.KendoGridOptions = {

                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: false,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },



                    columns: [
                         {
                        field: "ParentName",
                        title: "Parent",
                        hidden: true
                        },
                    {
                        field: "AccountCode",
                        title: "Account Code",
                        },
                    {
                        field: "AccountName",
                        title: "Account", 
                        },
                    {
                        field: "OpeningDebit",
                        title: "Opening Debit",
                        aggregates: ["sum"],
                        headerTemplate: kendo.template("<div class='headerright'>Opening Debit</div>"),
                        template: "<div style='text-align: right'>#=kendo.toString(OpeningDebit, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n2')#",
                        footerTemplate: "#= kendo.toString(sum, 'n2') #"
                    },
                        {
                        field: "OpeningCredit",
                        title: "Opening Credit",
                        aggregates: ["sum"],
                        headerTemplate: kendo.template("<div class='headerright'>Opening Credit</div>"),
                        template: "<div style='text-align: right'>#=kendo.toString(OpeningCredit, 'n')#</div>",
                         groupFooterTemplate: "#=kendo.toString(sum, 'n2')#",
                        footerTemplate: "#= kendo.toString(sum, 'n2') #"
                        },
                        {
                        field: "DebitTotal",
                        title: "Debit Total",
                        aggregates: ["sum"],
                        headerTemplate: kendo.template("<div class='headerright'>Debit Total</div>"),
                        template: "<div style='text-align: right'>#=kendo.toString(DebitTotal, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n2')#",
                        footerTemplate: "#= kendo.toString(sum, 'n2') #"
                        },
                        {
                        field: "CreditTotal",
                        title: "Credit Total",
                        aggregates: ["sum"],
                        headerTemplate: kendo.template("<div class='headerright'>Credit Total</div>"),
                        template: "<div style='text-align: right'>#=kendo.toString(CreditTotal, 'n')#</div>",
                         groupFooterTemplate: "#=kendo.toString(sum, 'n2')#",
                        footerTemplate: "#= kendo.toString(sum, 'n2') #"
                        },
                        {
                        field: "BalanceDebit",
                        title: "Balance Debit",
                        aggregates: ["sum"],
                        headerTemplate: kendo.template("<div class='headerright'>Balance Debit</div>"),
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceDebit, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n2')#",
                        footerTemplate: "#= kendo.toString(sum, 'n2') #"
                        },
                        {
                        field: "BalanceCredit",
                        title: "Balance Credit",
                        aggregates: ["sum"],
                        headerTemplate: kendo.template("<div class='headerright'>Balance Credit</div>"),
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceCredit, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n2')#",
                        footerTemplate: "#= kendo.toString(sum, 'n2') #"
                        },
                        {
                        field: "Balance",
                        title: "Balance",
                        aggregates: ["sum"],
                        headerTemplate: kendo.template("<div class='headerright'>Balance</div>"),
                        template: "<div style='text-align: right'>#=kendo.toString(Balance, 'n')#</div>",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n2')#",
                        footerTemplate: "#= kendo.toString(sum, 'n2') #"
                        },
                    ]
                };

            }
            

            $scope.Init = function () {

                //  $.LoadingOverlay("show", {
                //     image: "images/load.gif",
                // });

                $scope.loadKendoFunc();

            //      $scope.Ledgers = [];

            //     $scope.TotalOpeningDebit = 0;
            //     $scope.TotalOpeningCredit = 0;
            //     $scope.TotalDebitTotal = 0;
            //     $scope.TotalCreditTotal = 0;
            //     $scope.TotalBalanceDebit = 0;
            //     $scope.TotalBalanceCredit = 0;
            //     $scope.TotalBalance = 0;

            //    MainService.LedgerAccountBalances().then(function (response) {
            //         $scope.Ledgers = response.data;

            //     angular.forEach($scope.Ledgers, function(e){
            //         $scope.TotalOpeningDebit = $scope.TotalOpeningDebit + e.OpeningDebit ;
            //         $scope.TotalOpeningCredit = $scope.TotalOpeningCredit + e.OpeningCredit ;
            //         $scope.TotalDebitTotal = $scope.TotalDebitTotal + e.DebitTotal ;
            //         $scope.TotalCreditTotal = $scope.TotalCreditTotal + e.CreditTotal ;
            //         $scope.TotalBalanceDebit = $scope.TotalBalanceDebit + e.BalanceDebit ;
            //         $scope.TotalBalanceCredit = $scope.TotalBalanceCredit + e.BalanceCredit ;
            //         $scope.TotalBalance = $scope.TotalBalance + e.Balance ;
            //     })

            //         $.LoadingOverlay("hide");
            //     }, function (err) {
            //         $.LoadingOverlay("hide");
            //         toastr.error("Network Error");
            //         $scope.load = false;
            //     })

            }
            $scope.Init();




        }])
